import React, { useCallback, useMemo, useState } from 'react';
import { IItemForGetShortInfo } from 'types';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';
import SearchField from 'components/SearchField/SearchField';
import FormSelect from 'components/Select/FormSelect';
import style from './MultipleSelect.module.scss';

interface IProps {
	data: IItemForGetShortInfo[];
	refetch: () => void;
	responseError: boolean;
	setModifierGroups: (value: string[]) => void;
	IDsSelectedModifierGroups: string[];
}

export const MultipleSelect: React.FC<IProps> = React.memo(
	({ data, refetch, responseError, setModifierGroups, IDsSelectedModifierGroups }) => {
		const [searchString, setSearchString] = useState<string>('');

		const filteredModifierGroups = useMemo(() => {
			return searchString
				? data.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase()))
				: data;
		}, [searchString, data]);

		const handleSelectAllModifierGroups = useCallback(() => {
			if (data.length === IDsSelectedModifierGroups.length) {
				setModifierGroups([]);
			} else {
				const IDsOfAllModifierGroups = data.map((el) => el.id);
				setModifierGroups(IDsOfAllModifierGroups);
			}
		}, [setModifierGroups, data, IDsSelectedModifierGroups]);

		const renderSelectMenu = useCallback(
			(menu: React.ReactElement) => {
				const getIsCheckedByHasAccess = () => {
					return !!(data.length && data.length === IDsSelectedModifierGroups.length);
				};

				return (
					<>
						<div className={style.selectMenuHeader}>
							<Checkbox
								className={style.checkBox}
								checked={getIsCheckedByHasAccess()}
								disabled={!data.length}
								onChange={handleSelectAllModifierGroups}>
								<Text
									translationNameSpace="form"
									translationKey="selectAllModifierGroupsLabel"
									asFragment={true}
								/>
							</Checkbox>
							<SearchField
								onChangeSelectSearchString={setSearchString}
								searchString={searchString}
								className={style.searchField}
							/>
						</div>
						{menu}
					</>
				);
			},
			[data, IDsSelectedModifierGroups, handleSelectAllModifierGroups, setSearchString, searchString],
		);

		return (
			<FormSelect
				testId="MultipleSelect"
				name="IDsSelectedModifierGroups"
				label="modifiersGroupLabel"
				options={filteredModifierGroups}
				fetchError={responseError}
				onRefetch={refetch}
				onChange={setModifierGroups}
				counterValue={IDsSelectedModifierGroups.length}
				dropdownRender={renderSelectMenu}
				mode="multiple"
			/>
		);
	},
);
